// import {localStorage} from "@/util";
import {TokenKeys} from "@/util/variable";
const actions={
  setStoreLanguage({ commit }, storeLanguage) {
    return new Promise((resolve, reject) => {
      commit('SET_STORE_LANGUAGE', storeLanguage);
      localStorage.setItem(TokenKeys.LANGUAGE,storeLanguage);
      resolve()
    })
  }
};
export default actions



// WEBPACK FOOTER //
// ./src/vuex/actions.js